import { S } from './state.js';
import { Audio } from './audio.js';
import { ctx } from './canvas.js';
import { ACHIEVEMENTS, UNLOCKS } from './data/progression.js';
import { RELIC_TIERS } from './data/relics.js';
import { persist } from './economy.js';
import { roundRect } from './screens.js';
// ---- Unlocks ----
export function checkUnlocks(silent) {
  if (!S.save.unlocks) S.save.unlocks = {};
  for (const ul of UNLOCKS) {
    if (!S.save.unlocks[ul.key] && ul.cond(S.save)) {
      S.save.unlocks[ul.key] = true;
      if (!silent) { S.pendingUnlocks.push(ul); Audio.play('powerup'); }
    }
  }
}
// ---- Achievements ----
export function checkAchievements(silent) {
  if (!S.save.achievements) S.save.achievements = {};
  let awarded = false;
  for (const a of ACHIEVEMENTS) {
    if (S.save.achievements[a.key]) continue;
    let ok = false; try { ok = !!a.cond(); } catch (e) {}   // cond reads live state; guard against any TDZ at load
    if (!ok) continue;
    S.save.achievements[a.key] = true; awarded = true;
    if (!silent) { S.achToasts.push({ ach: a, life: 200 }); Audio.play('powerup'); }
  }
  if (awarded) persist();
}
// floating "Achievement unlocked" banners (top-center) — drawn every render frame so they fade in real time
export function drawAchToasts() {
  if (!S.achToasts.length) return;
  ctx.save();
  let ty = 92;
  for (const t of S.achToasts) {
    const fade = t.life > 170 ? (200 - t.life) / 30 : t.life < 30 ? t.life / 30 : 1;
    ctx.globalAlpha = Math.max(0, Math.min(1, fade));
    const bw = 320, bh = 50, bx = (S.W - bw) / 2;
    ctx.fillStyle = 'rgba(18,16,10,.95)'; roundRect(bx, ty, bw, bh, 12); ctx.fill();
    ctx.strokeStyle = 'rgba(255,210,110,.7)'; ctx.lineWidth = 1.5; ctx.stroke();
    ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.font = '26px system-ui'; ctx.fillStyle = '#fff'; ctx.fillText(t.ach.icon, bx + 16, ty + bh / 2 + 1);
    ctx.font = 'bold 10px system-ui'; ctx.fillStyle = '#ffd66e'; ctx.fillText('🏅 ACHIEVEMENT UNLOCKED', bx + 52, ty + 17);
    ctx.font = 'bold 15px system-ui'; ctx.fillStyle = '#fff'; ctx.fillText(t.ach.name, bx + 52, ty + 34);
    t.life--; ty += bh + 8;
  }
  ctx.globalAlpha = 1; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
  ctx.restore();
  S.achToasts = S.achToasts.filter(t => t.life > 0);
}
// floating "Relic recovered" banners (top-center, under the achievement banners) — tier-colored
export function drawRelicToasts() {
  if (!S.relicToasts || !S.relicToasts.length) return;
  ctx.save();
  let ty = 150;   // sit below the achievement toasts (which start at 92)
  for (const t of S.relicToasts) {
    const life0 = t.life0 || (t.dupe ? 220 : 260);
    const fade = t.life > life0 - 30 ? (life0 - t.life) / 30 : t.life < 30 ? t.life / 30 : 1;
    ctx.globalAlpha = Math.max(0, Math.min(1, fade));
    const col = (RELIC_TIERS[t.relic.tier] || {}).color || '#c9a3ff';
    const bw = 340, bh = 50, bx = (S.W - bw) / 2;
    ctx.fillStyle = 'rgba(14,12,22,.95)'; roundRect(bx, ty, bw, bh, 12); ctx.fill();
    ctx.strokeStyle = col; ctx.lineWidth = 1.5; ctx.stroke();
    ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.font = '26px system-ui'; ctx.fillStyle = '#fff'; ctx.fillText(t.relic.icon, bx + 16, ty + bh / 2 + 1);
    const stars = '★'.repeat(t.level || 1);   // 0.26 fusion: show the star level reached
    const tag = t.maxed ? '✦ MAX ' + stars + ' — +' + t.refund + ' XP'
              : t.upgrade ? '✦ FUSED → ' + stars
              : t.dupe ? '✦ DUPLICATE — +' + t.refund + ' XP'
              : '✦ RELIC RECOVERED';
    ctx.font = 'bold 10px system-ui'; ctx.fillStyle = col; ctx.fillText(tag, bx + 52, ty + 17);
    ctx.font = 'bold 15px system-ui'; ctx.fillStyle = '#fff'; ctx.fillText(t.relic.name, bx + 52, ty + 34);
    t.life--; ty += bh + 8;
  }
  ctx.globalAlpha = 1; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
  ctx.restore();
  S.relicToasts = S.relicToasts.filter(t => t.life > 0);
}
